import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table" }
const _hoisted_7 = { class: "table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Détails des contrats", -1)),
            _createVNode(_component_router_link, {
              to: "/liste-contrats",
              class: "btn btn-primary transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1),
                _createElementVNode("span", { class: "position-relative" }, null, -1),
                _createTextVNode("Retour")
              ])),
              _: 1
            })
          ]),
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[2] || (_cache[2] = _createElementVNode("td", null, "Référence :", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.contrat?.reference), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[3] || (_cache[3] = _createElementVNode("td", null, "Place:", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.contrat?.place?.code), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[4] || (_cache[4] = _createElementVNode("td", null, "Marchand :", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.contrat?.usager?.nom +' '+ _ctx.contrat?.usager?.prenom), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[5] || (_cache[5] = _createElementVNode("td", null, "Date mise en service :", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.contrat?.dateMiseEnService), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[6] || (_cache[6] = _createElementVNode("td", null, "Loyer :", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.contrat?.loyer), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[7] || (_cache[7] = _createElementVNode("td", null, "Montant :", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.contrat?.montantContrat), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[8] || (_cache[8] = _createElementVNode("td", null, "Observation :", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.contrat?.observation), 1)
              ])
            ])
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("h5", { class: "mt-4" }, "Éléments Électriques", -1)),
          _createElementVNode("table", _hoisted_7, [
            _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "Désignation"),
                _createElementVNode("th", null, "Quantité"),
                _createElementVNode("th", null, "Prix"),
                _createElementVNode("th", null, "Montant")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contrat?.contratElements, (element) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: element.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(element.element.designation), 1),
                  _createElementVNode("td", null, _toDisplayString(element.quantite), 1),
                  _createElementVNode("td", null, _toDisplayString(element.prix), 1),
                  _createElementVNode("td", null, _toDisplayString(element.montant), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}